<template>
  <div id="page-events">

    <!-- ═════ Hero (background + headings) ═════ -->
    <div class="hero" v-if="settings.public_event.public_path">
      <img
        :src="settings.public_event.public_path"
        alt="Preview"
        class="hero-img"
      />

      <!-- overlay holds the H1/H2 only -->
      <div class="hero-overlay">
        <div class="hero-center">
          <h1>{{ settings.public_event.header_text }}</h1>
          <h2>{{ settings.public_event.subheader_text }}</h2>
        </div>
      </div>
    </div>

    <!-- ═════ Regular page content (below the hero) ═════ -->
    <section class="page-wrapper">
      <div class="page-center">

        <m-row>
          <m-col lg="12">
            <div class="toolbar">
              <memlist-checkbox
                variant="event"
                v-model="show_closed"
                :title="`Visa stängda`"
              />

              <memlist-checkbox
                variant="event"
                v-model="show_full"
                :title="`Visa fullbokade`"
                class="ml-16"
              />

              <div class="btn-group">
                <button
                  class="icon-btn"
                  :class="{ active: viewMode === 'grid' }"
                  @click="viewMode = 'grid'"
                  aria-label="Rutnät"
                >
                  <span class="svg-icon-event-blue">
                    <inline-svg src="/assets/svg/grid2.svg"></inline-svg>
                  </span>
                </button>

                <button
                  class="icon-btn"
                  :class="{ active: viewMode === 'list' }"
                  @click="viewMode = 'list'"
                  aria-label="Lista"
                >
                  <span class="svg-icon-event-blue">
                    <inline-svg src="/assets/svg/list.svg"></inline-svg>
                  </span>
                </button>

                <button
                  class="icon-btn"
                  :class="{ active: viewMode === 'map' }"
                  @click="viewMode = 'map'"
                  aria-label="Karta"
                >
                  <span class="svg-icon-event-blue">
                    <inline-svg src="/assets/svg/map.svg"></inline-svg>
                  </span>
                </button>
              </div>
            </div>
          </m-col>
        </m-row>

        <div v-if="viewMode === 'grid'">

        
          <m-row>
            <m-col lg="3" class="mb-14">
              <NewPublicEventListItem 
                :item="{}"
              />
              
            </m-col>
            <m-col lg="3" class="mb-14">
              <NewPublicEventListItem 
                :item="{}"
              />
            </m-col>
            <m-col lg="3" class="mb-14">
              <NewPublicEventListItem 
                :item="{}"
              />
            </m-col>
            <m-col lg="3" class="mb-14">
              <NewPublicEventListItem 
                :item="{}"
              />
            </m-col>
          </m-row>

          <m-row>
            <m-col lg="3" class="mb-14">
              <NewPublicEventListItem 
                :item="{}"
              />
              
            </m-col>
            <m-col lg="3" class="mb-14">
              <NewPublicEventListItem 
                :item="{}"
              />
            </m-col>
            <m-col lg="3" class="mb-14">
              <NewPublicEventListItem 
                :item="{}"
              />
            </m-col>
            <m-col lg="3" class="mb-14">
              <NewPublicEventListItem 
                :item="{}"
              />
            </m-col>
          </m-row>
        </div>

        <div v-else-if="viewMode === 'list'">

          <m-row>
            <m-col lg="12" class="mb-8">
              <NewPublicEventListRowItem 
                :item="{}"
              />
              
            </m-col>
            <m-col lg="12" class="mb-8">
              <NewPublicEventListRowItem 
                :item="{}"
              />
            </m-col>
            <m-col lg="12" class="mb-8">
              <NewPublicEventListRowItem 
                :item="{}"
              />
            </m-col>
            <m-col lg="12" class="mb-8">
              <NewPublicEventListRowItem 
                :item="{}"
              />
            </m-col>
          </m-row>

          <m-row>
            <m-col lg="12" class="mb-8">
              <NewPublicEventListRowItem 
                :item="{}"
              />
              
            </m-col>
            <m-col lg="12" class="mb-8">
              <NewPublicEventListRowItem 
                :item="{}"
              />
            </m-col>
            <m-col lg="12" class="mb-8">
              <NewPublicEventListRowItem 
                :item="{}"
              />
            </m-col>
            <m-col lg="12" class="mb-8">
              <NewPublicEventListRowItem 
                :item="{}"
              />
            </m-col>
          </m-row>
        </div>

        <div v-else-if="viewMode === 'map'">
          <memlist-inline-alert>
            Det finns inga evenemang med kartposition aktiverat
          </memlist-inline-alert>
        </div>

      </div>
    </section>
  
  </div>
</template>

<script>
import messageParent from '@/core/services/messageParent';
import axios from 'axios';
import dayjs, { Dayjs } from 'dayjs';
import { mapGetters } from 'vuex';
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';
import i18nService from "@/core/services/i18n.service.js";
import NewPublicEventListItem from './NewPublicEventListItem.vue';
import NewPublicEventListRowItem from './NewPublicEventListRowItem.vue';


export default {
  name: 'NewpublicEventList',
  components: {
    NewPublicEventListItem,
    NewPublicEventListRowItem,
  },
  mixins: [ toasts ],
  computed: {
    ...mapGetters(['currentMember'])
  },
  async mounted() {
    this.load_public_list();
  },
  data() {
    return {

      viewMode: 'grid',   // 'grid' | 'list'
      showMap: false,
      
      show_closed: false,
      show_full: false,
      loading: true,

      no_events: true,
      events: [],
      settings: {
        public_event: {}
      },
      company: {},
    };
  },
  watch: {
  
  },
  methods: {

    async load_public_list() {
      this.loading = true;

      try {
        const res = await axios.get(`/events/listforpublic`);

        if (res.status === 200) {
          this.events = res.data.events;
          this.settings = res.data.settings;

          if (!this.settings.public_event) {
            this.settings.public_event = {};
          }
        }
      }
      catch (err) {
        console.error('load_public_list error', err);
      }
      
      this.no_events = this.events.length === 0;
      this.loading = false;

    },

    
    async load_company() {
      try {
        const res = await axios.get(`/company/public/${this.company.company_id}`);
        
        if (res.status === 200) {
          this.company = res.data;
        }
      }
      catch (err) {
        console.error('load_company error', err);
        this.toastr('danger', this.$t('COMMON.ERROR'), 'Kunde inte hämta förening');
      }
    },
    
  }
};
</script>
<style scoped>

.hero          { position: relative; width: 100%; overflow: hidden; }
.hero-img      { display: block; width: 100%; height: auto; }

.hero-overlay  {
  position: absolute;
  inset: 0;                          /* top:0 right:0 bottom:0 left:0 */
  display: flex;
  justify-content: center;           /* centre column horizontally    */
  align-items: flex-end;             /* pin column to bottom of photo */
  pointer-events: none;
}

.hero-center   {                     /* headings column */
  pointer-events: auto;
  width: 100%;
  max-width: 1024px;                 /* fixed width on desktop        */
  padding: 2rem;
  color: #fff;
  text-shadow: 0 2px 4px rgba(0,0,0,.6);
}

/* ───────── page-content styles ───────── */
.page-wrapper  {                     /* full-width bar that centers child */
  display: flex;
  justify-content: center;
  padding: 2rem 0;
}

.page-center   {                     /* same sizing as hero-center */
  width: 100%;
  max-width: 1024px;
  padding: 0 2rem;
  box-sizing: border-box;
}

/* keep / tweak your heading styles */
h1 { font-size: 46px; font-weight: 500; margin: 0 0 .25em; }
h2 { font-size: 24px; margin: 0 0 1em; }

/* ─── toolbar layout ─── */
.toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1.5rem;
}

/* check-box label */
.chk {
  display: flex;
  align-items: center;
  margin-right: 1rem;
  font-size: .875rem;
  color: #495057;
}
.chk input {
  margin-right: .35rem;
}

/* button group on the right */
.btn-group {
  display: flex;
  gap: .5rem; /* space between buttons */
  margin-left: auto; /* push group to the far right */
}

/* square icon button */
.icon-btn {
  width: 36px;
  height: 36px;
  padding: 0;
  border: 1px solid #ced4da;
  border-radius: 4px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background .15s, border-color .15s;
}
.icon-btn svg {
  width: 18px;
  height: 18px;
  fill: currentColor;
}

/* hover / focus */
.icon-btn:hover,
.icon-btn:focus {
  background: #f1f3f5;
}

/* active (toggled) state */
.icon-btn.active {
  background: #35aaca;
  border-color: #35aaca;
  color: #fff;
}

/* default (inactive) colour */
.icon-btn:not(.active) .svg-icon-event-blue,
.icon-btn:not(.active) .svg-icon-event-blue * {
  color: #35aaca;
  fill: currentColor;        /* SVG paths follow the text colour */
}

/* active → invert to white */
.icon-btn.active .svg-icon-event-blue,
.icon-btn.active .svg-icon-event-blue * {
  color: #fff;
  fill: currentColor;
}

</style>